import React from 'react';

import BreadcrumbsNext from 'ha/components/next/Breadcrumbs';
import { useIntl } from 'ha/i18n';
import { CanonicalCollections } from 'ha/constants/SearchPageCollections';
import { notEmpty } from 'ha/utils/notEmpty';

interface Props {
  city: string;
  params: {
    location: string;
    localizedKind?: string;
  };
  isSearchByPartner: boolean;
  canonicalCollection: string | null;
  isAdvertiserSearch: boolean;
  advertiserName: string;
}

const SearchPageBreadcrumbs: React.FC<Props> = ({
  canonicalCollection,
  city,
  params,
  isSearchByPartner,
  isAdvertiserSearch,
  advertiserName,
}) => {
  const { T, urlResolver } = useIntl();

  let breadcrumbsCategory;
  let categorySearchURL;

  if (canonicalCollection) {
    breadcrumbsCategory = {
      [CanonicalCollections.ApartmentForRent]: T(
        'seo_search_breadcrumb_apartment_for_rent',
      ),
      [CanonicalCollections.PrivateRoomForRent]: T(
        'seo_search_breadcrumb_private_room_for_rent',
      ),
      [CanonicalCollections.SharedRoomForRent]: T(
        'seo_search_breadcrumb_shared_room_for_rent',
      ),
      [CanonicalCollections.StudioForRent]: T(
        'seo_search_breadcrumb_studio_for_rent',
      ),
      [CanonicalCollections.CheapAccommodation]: T(
        'seo_search_breadcrumb_cheap_accommodation',
      ),
      [CanonicalCollections.FurnishedApartments]: T(
        'seo_search_breadcrumb_furnished_apartments',
      ),
      [CanonicalCollections.StudentAccommodation]: T(
        'seo_search_breadcrumb_student_accommodation',
      ),
      [CanonicalCollections.LongTermRentals]: T(
        'seo_search_breadcrumb_long_term_rentals',
      ),
      [CanonicalCollections.OneBedroomApartments]: T(
        'seo_search_breadcrumb_one_bedroom_apartments',
      ),
      [CanonicalCollections.TwoBedroomApartments]: T(
        'seo_search_breadcrumb_two_bedroom_apartments',
      ),
      [CanonicalCollections.StudentRoom]: T(
        'seo_search_breadcrumb_student_room',
      ),
    }[canonicalCollection];

    categorySearchURL = urlResolver.absolutizePath(
      `/s/${params.location}${
        params.localizedKind ? `/${params.localizedKind}` : ''
      }`,
    );
  }

  const mainSearchUrl = urlResolver.absolutizePath(`/s/${params.location}`);

  const breadcrumbs = [
    {
      name: city,
      path: mainSearchUrl,
    },
    breadcrumbsCategory
      ? {
          name: breadcrumbsCategory,
          path: categorySearchURL,
        }
      : null,
    isAdvertiserSearch
      ? {
          name: advertiserName,
        }
      : null,
  ].filter(notEmpty);

  return (
    <BreadcrumbsNext
      breadcrumbs={breadcrumbs}
      withJsonLDSchema={!isSearchByPartner}
    />
  );
};

export default SearchPageBreadcrumbs;
